<template>
  <div
    v-if="
      auth.user.selectedAccess.roleLevel > 2 ||
        (subdistributor &&
          auth.user.selectedAccess.subdistributor_id == subdistributor.id)
    "
  >
    <loading-spinner v-if="!subdistributor" />
    <app-header
      v-if="subdistributor"
      :title="subdistributor.name"
      :subtitle="`${getLabel('SUBDISTRIBUTOR')} #${subdistributor.id}`"
    >
      <template #col-right>
        <div
          v-if="
            auth.user.selectedAccess.roleLevel >= 3 &&
              auth.user.selectedAccess.can_modify_settings
          "
        >
          <b-button
            v-router-link="{
              name: 'subdistributor-editor',
              query: { id: subdistributor.id },
            }"
            variant="primary"
            size="lg"
          >
            <i class="fa fa-pencil-square-o" style="font-size:20px" />&nbsp;
            <span v-label-key="'EDIT_SUBDISTRIBUTOR'">Edit Subdistributor</span>
          </b-button>
        </div>
      </template>
    </app-header>

    <b-container>
      <b-nav tabs class="mb-3">
        <b-nav-item :to="{ name: 'subdistributor-reports-tab' }">
          <span v-label-key="'REPORTS'">Reports</span>
        </b-nav-item>
        <b-nav-item :to="{ name: 'subdistributor-transactions-tab' }">
          <span v-label-key="'TRANSACTIONS'">Transactions</span>
        </b-nav-item>
        <b-nav-item :to="{ name: 'subdistributor-chains-tab' }">
          {{ getLabel('CHAINS') }} ({{ summary?.chainCount || 0 }})
        </b-nav-item>
        <b-nav-item :to="{ name: 'subdistributor-stores-tab' }">
          {{ getLabel('STORES') }} ({{ summary?.storeCount || 0 }})
        </b-nav-item>
        <b-nav-item
          v-if="auth.user.selectedAccess.roleLevel > 2"
          :to="{ name: 'subdistributor-users-tab' }"
        >
          {{ getLabel('USERS') }} ({{ summary?.userCount || 0 }})
        </b-nav-item>
        <b-nav-item
          v-if="
            auth.user.selectedAccess.roleLevel > 3 &&
              getShowTab('warranty_settings')
          "
          :to="{ name: 'subdistributor-extended-warranty-tab' }"
        >
          <span v-label-key="'WARRANY_SETTINGS'">Warranty Settings</span>
        </b-nav-item>
        <b-nav-item
          v-if="getShowTab('lifetime_warranty')"
          :to="{ name: 'subdistributor-lifetime-warranty-tab' }"
        >
          <span v-label-key="'LIFETIME_WARRANTY'">Lifetime Warranty</span>
        </b-nav-item>
        <b-nav-item :to="{ name: 'subdistributor-about-tab' }">
          <span v-label-key="'ABOUT'">About</span>
        </b-nav-item>
        <b-nav-item :to="{ name: 'subdistributor-screensavers-list-tab' }">
          <span v-label-key="'SCREENSAVERS'">Screensavers</span>
        </b-nav-item>

        <b-nav-item
          v-if="auth.user.selectedAccess.roleLevel > 3"
          :to="{ name: 'subdistributor-template-types-tab' }"
        >
          <span v-label-key="'TEMPLATE_TYPES'">Template Types</span>
        </b-nav-item>

        <b-nav-item
          v-if="auth.user.selectedAccess.roleLevel > 3"
          :to="{ name: 'subdistributor-settings-tab' }"
        >
          <span v-label-key="'CHAIN_SETTINGS'">Chain Settings</span>
        </b-nav-item>
        <b-nav-item
          v-if="auth.user.selectedAccess.roleLevel > 3"
          :to="{ name: 'subdistributor-store-settings-tab' }"
        >
          <span v-label-key="'STORE_SETTINGS'">Store Settings</span>
        </b-nav-item>
        <b-nav-item
          v-if="auth.user.selectedAccess.can_manage_staff"
          :to="{ name: 'subdistributor-staff-tab' }"
        >
          <span v-label-key="'STAFF'">Staff</span> ({{ summary?.retailStaffCount || 0 }})
        </b-nav-item>
      </b-nav>
      <div>
        <router-view v-if="subdistributor"
            :subdistributor_id="$route.params.id" :distributor_id="subdistributor?.distributor_id"
          />
      </div>
    </b-container>
  </div>
</template>

<script>
import $auth from '@/services/auth';
import $api from '@/services/api';
import { mapGetters } from 'vuex';
import LoadingSpinner from '@/components/LoadingSpinner';
import AppHeader from '@/components/AppHeader';

export default {
  components: {
    LoadingSpinner,
    AppHeader,
  },

  data() {
    return {
      auth: $auth,
      subdistributor: null,
      summary: {},
    };
  },

  computed: {
    ...mapGetters('config', ['getShowTab']),
    ...mapGetters('translations', {
      getLabel: 'getLabel',
    }),
  },

  created() {
    this.refreshData();
  },

  methods: {
    refreshData() {
      this.$store.commit('global/clearAllState');

      $api
        .get(`/v1/dashboard/subdistributors/${this.$route.params.id}`)
        .then(subdistributor => {
          this.subdistributor = subdistributor;

          $api
          .get(`/v1/dashboard/subdistributors/summary?subdistributor_id=${subdistributor.id}&distributor_id=${subdistributor.distributor_id}`)
          .then((response) => {
            this.summary = response;
          });

          // const payload = {
          //   subdistributor_id: subdistributor.id,
          //   distributor_id: subdistributor.distributor_id,
          // };
          // this.$store.dispatch('global/getChains', payload);
          // this.$store.dispatch('global/getStores', payload);
          // this.$store.dispatch('global/getUsers', {
          //   subdistributor_id: subdistributor.id,
          // });
        });
    },
  },
};
</script>

<style scoped>
a {
  color: black;
}
</style>
